
    import {Options, Vue} from 'vue-property-decorator';
    import BottomSheetDisplayer from '@/common/ui/BottomSheetDisplayer';
    import {getTipsClassPosition} from '@/common/ui/GetTipsClassPosition';

    @Options({})
    export default class RecommendationSide extends Vue {
        tipsClassPosition = getTipsClassPosition(85);

        mounted(): void {
            this.bottomSheetDisplayer = new BottomSheetDisplayer('', '', this.$el, 'div.profile-creation-wizard');
            this.bottomSheetDisplayer.mounted();
        }
    }
